export default class ContentAvailableLanguages {
    constructor(element) {
        this.el = element

        this.init()
    }

    async init() {
        try {
            this.availableLanguages = await this.getAvailableLanguagesFromLanguagesSwitcher()
            this.createLinks()
        } catch (error) {
            console.error('Error getting available languages:', error);
        }
    }

    getAvailableLanguagesFromLanguagesSwitcher() {
        return new Promise((resolve, reject) => {
            const selector = document.querySelector('.t-select-locale');
            if (!selector) {
                reject('Language switcher not found.');
                return;
            }
            const options = selector.querySelectorAll('option');
            const availableLanguages = Array.from(options).map(option => ({
                url: option.value,
                label: option.dataset.label,
                lang: option.dataset.lang
            }));
            resolve(availableLanguages);
        });
    }

    createLinks() {
        this.availableLanguages.forEach((obj) => {
            const wrapper = document.createElement('div')
            wrapper.classList.add('content-available-languages__wrapper', 'u-flex', 'u-align-items-center', 'u-gap10', 'u-mb5', 't-decoration-none', 't-fs16', 't-fs13--s')

            const flag = document.createElement('img')
            flag.classList.add('w20px')
            flag.setAttribute('src', `/themes/custom/ifri/img/icons/${obj.lang.toLowerCase()}.svg`)
            flag.setAttribute('alt', obj.lang)
            wrapper.appendChild(flag)

            const link = document.createElement('a')
            link.classList.add('content-available-languages__link')
            link.setAttribute('href', obj.url)
            link.innerHTML = obj.label
            wrapper.appendChild(link)

            this.el.appendChild(wrapper)
        })
    }

}
